<template>
  <div class="app">
    <MobileNav />
    <div class="content">
      <router-view v-slot="{ Component, route }">
        <transition name="fade">
          <component :is="Component" :key="route.fullPath" />
        </transition>
      </router-view>
    </div>
  </div>
</template>

<script>
import MobileNav from './components/MobileNav.vue'
export default {
  name: 'App',
  components: { MobileNav }
}
</script>

<style>
:root {
  --primary-color: #6c5ce7;
  --background-dark: #0E0C1F;
  --surface-dark: #1a1a2e;
  --text-primary: #ffffff;
  --text-secondary: #a0a0b0;
  --gradient-1: #6c5ce7;
  --gradient-2: #a29bfe;
  --gradient-3: #fd79a8;
  --gradient-4: #e84393;

  /* Shared dashboard design tokens (used by src/components/ui/*) */
  --panel-bg: rgba(26, 27, 46, 0.95);
  --panel-border: rgba(255, 255, 255, 0.1);
  --border-soft: rgba(255, 255, 255, 0.08);
  --hover-bg: rgba(255, 255, 255, 0.05);
  --field-bg: rgba(255, 255, 255, 0.05);
  --radius-lg: 14px;
  --radius: 10px;
  --radius-sm: 8px;
  --primary-rgb: 108, 92, 231;
  --primary-glow: rgba(108, 92, 231, 0.35);
  --danger: #ff6b6b;
  --success: #4ade80;
  --warning: #f8bf71;
  --info: #22d3ee;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  overflow: hidden;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  background-color: var(--background-dark);
  color: var(--text-primary);
}

.app {
  height: 100vh;
  position: relative;
  overflow: hidden;
}

.content {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media (max-width: 768px) {
  .content {
    padding: 0;
  }
}
</style>
